module.exports = __webpack_public_path__ + "static/media/iconoFlechaIzquierdaAzul.d2f5060f.svg";